/* sk-pages-xsell-bridge.js — Lexikon-Cross-Sell-Karten (sk-xsell.js) mit dem Horizon-Header und dem sk-Drawer verbinden.
   sk-xsell.js meldet "In den Warenkorb" per window-Event "cartcount:update" (Empire). Horizon kennt dieses Event nicht:
   Header-Zähler und Drawer reagieren nicht. Diese Brücke zieht den Zähler nach und öffnet den Drawer über das
   Header-Warenkorb-Icon (assets/sk-cart-bridge.js lädt dabei auch die Video-Gate-Daten). */
(function () {
  'use strict';
  if (window.__skPagesXsellBridge) return;
  window.__skPagesXsellBridge = true;

  function updateCount(cart) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (n === null) return;
    var counts = document.querySelectorAll('.cart-bubble__text-count');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = n > 99 ? '' : n;
      counts[i].classList.toggle('hidden', n === 0);
      var bubble = counts[i].closest('.cart-bubble');
      if (bubble) bubble.classList.toggle('visually-hidden', n === 0);
    }
  }

  window.addEventListener('cartcount:update', function (event) {
    updateCount(event && event.detail);
    if (/\/cart\/?$/.test(window.location.pathname)) return;
    window.setTimeout(function () {
      var trigger = document.querySelector('.action__cart, [data-sk-open-drawer]');
      if (trigger) {
        trigger.click();
      } else if (window.skDrawer && typeof window.skDrawer.open === 'function') {
        window.skDrawer.open();
      }
    }, 150);
  });
})();
